import axios from "axios";
import Swal from "sweetalert2";
import Riyal from "../../ui/riyal";
import getToken from "../../../hooks/getToken";

import { useNavigate, useParams } from "react-router-dom";
import { useUserSelection } from "../../../store/UserPayment";
import React, { useEffect, useState } from "react";
import { useMutation } from "@tanstack/react-query";
import { useLanguage } from "../../../store/language-context";
import { useTranslation } from "react-i18next";

export default function TRCourseTable({ table, error, isLoading }) {
    const { URL } = useLanguage();
    const { t } = useTranslation();
    const { id } = useParams();
    const navigate = useNavigate();
    const token = getToken();
    const { setSelectedPayment, setRowDetails, rowDetails } = useUserSelection();
    const [rowIndex, setRowIndex] = useState(null);

    const courseMutation = useMutation({
        mutationKey: ['table-row'],
        mutationFn: async ({ rowId, price }) => {
            setRowIndex(rowId);

            if (!token) {
                navigate('/login');
                return;
            }
            const response = await axios.post(`${URL}/course-register`, {
                course_id: rowDetails?.courseId,
                city_month_data_id: rowId,
                price: price,
            }, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json"
                }
            });

            const courseData = {
                course_id: rowDetails?.courseId,
                city_month_data_id: rowId,
                price: price,
            };

            localStorage.setItem(`price_id`, JSON.stringify(courseData));
            return response
        },
        onError: (error) => {
            if (error?.response?.data?.message?.includes('User has already completed or is pending')) {
                Swal.fire({
                    icon: 'error',
                    title: t('training-courses.registered-before'),
                    confirmButtonText: t('custom.accept')
                })
            } else {
                Swal.fire({
                    icon: 'error',
                    title: t('custom.err'),
                    confirmButtonText: t('custom.accept')
                })
            }
        },
        onSuccess: (response) => {
            const dataOfRow = response?.data?.data;
            setRowDetails(prev => ({
                ...prev,
                courseId: id,
                thisUserId: dataOfRow?.user_id,
                thisCompanyId: dataOfRow?.company_id,
                courseRegistrationId: dataOfRow?.id,
                userToken: token,
                thisRowPrice: dataOfRow?.price,
                theImgUploaded: '',
            }));
            navigate(`/training-courses/${rowDetails?.courseId}/payment/way`);
        }
    });

    useEffect(() => {
        const timeoutId = setTimeout(() => {
            localStorage.removeItem('price_id');
        }, 300000);


        return () => clearTimeout(timeoutId);

    }, []);

    return (
        <div className="scrolling see-scroll-bar">
            {
                error ?
                    <div className="flex justify-center items-center p-5">
                        <p>{error?.message}</p>
                    </div>
                    :
                    table?.length > 0 &&
                    <table className="w-full text-nowrap bg-[#FAFAFA] overflow-y-scroll" style={{ borderRadius: '7px' }}>
                        <thead className="border-b border-gray-100 bg-[#FAFAFA]  sticky top-0">
                            <tr className="grid grid-cols-5 w-full !text-start p-3 text-primary-tw border rounded-md">
                                {/* <td>الموقع</td> */}
                                <td>{t('contact.start-date')}</td>
                                <td className="rtl:lg:pr-8 ltr:lg:pl-8">{t('contact.end-date')}</td>
                                <td className="rtl:lg:pr-12">{t('training-courses.duration')}</td>
                                <td className="rtl:lg:pr-12">{t('training-courses.total-price')}</td>
                                <td className="rtl:lg:pr-20 ltr:lg:pl-20">{t('training-courses.actions')}</td>
                            </tr>
                        </thead>
                        <tbody>
                            {table?.map((data, i) => {
                                const startDate = new Date(data?.start_date);
                                const endDate = new Date(data?.end_date);
                                const diffMilliSec = endDate - startDate;
                                const diffInDays = diffMilliSec / (1000 * 60 * 60 * 24) + 1;
                                return (
                                    <React.Fragment key={i}>
                                        {isLoading ? (
                                            <tr className="flex justify-between w-full" key={i}>
                                                <td className="w-24 h-5 rounded-md l-load-dt m-2"></td>
                                                <td className="w-24 h-5 rounded-md l-load-dt m-2"></td>
                                                <td className="w-24 h-5 rounded-md l-load-dt m-2"></td>
                                                <td className="w-24 h-5 rounded-md l-load-dt m-2"></td>
                                                <td className="w-24 h-8 rounded-md l-load-dt m-2"></td>
                                            </tr>
                                        ) : (
                                            <tr className="flex justify-between w-full p-3 max-lg:gap-7"
                                                style={{ borderColor: '#D9D9D9', borderStyle: 'solid', borderWidth: '0 0 1px 0' }} key={i}>
                                                {/* <td>{data?.city?.title || "_____"}</td> */}
                                                <td>{data?.start_date || "_____"}</td>
                                                <td>{data?.end_date || "_____"}</td>
                                                <td>
                                                    {diffInDays || "_____"}
                                                    {!isNaN(diffInDays) && (diffInDays === 1 ? t('training-courses.day') : t('training-courses.days'))}
                                                </td>
                                                <td style={{ display: 'flex', alignItems: 'center', gap: '2px' }}>
                                                    {data?.price || "_____"} {data?.currency?.title?.includes('ريال') ? <Riyal color="black" /> : data?.currency?.title || "_____"}</td>
                                                <td
                                                    onClick={() => {
                                                        if (!token) {
                                                            navigate('/login');
                                                            return;
                                                        }
                                                        const updatedPayment = {
                                                            location: data?.city?.title,
                                                            currencyTitle: data?.currency?.title?.includes('ريال') ? <Riyal /> : data?.currency?.title,
                                                            startDate: data?.start_date,
                                                            endDate: data?.end_date,
                                                            duration: diffInDays,
                                                        };

                                                        localStorage.setItem('selectedPayment', JSON.stringify(updatedPayment));

                                                        setSelectedPayment(prev => ({
                                                            ...prev,
                                                            ...updatedPayment,
                                                        }));

                                                        courseMutation.mutate({ rowId: data?.id, price: data?.price });
                                                    }}

                                                    className="w-24 py-1 text-white flex justify-center items-center rounded-md bg-primary-tw cursor-pointer"
                                                    title="التقديم في الكورس">
                                                    {(rowIndex === data?.id && courseMutation.isPending) ?
                                                        <div className="flex justify-center items-center gap-2">
                                                            <div className="size-6 border-2 border-gray-200 rounded-full animate-spin-slow border-t-transparent"></div>
                                                        </div>
                                                        :
                                                        t('custom.check')
                                                    }
                                                </td>
                                            </tr>
                                        )}
                                        {i !== table?.length - 1 && (
                                            <tr className="no-pm w-full h-[0.4px] bg-gray-400"></tr>
                                        )}
                                    </React.Fragment>
                                );
                            })}
                        </tbody>
                    </table>
            }
        </div>
    );
}